import React, { FC, Fragment } from 'react';
//styles
import {
  Container,
  Divider,
  Row,
  Section,
  Title,
  Value
} from '../cardIOSDetails.styles';
//types
import { StoreCardDetailsProps } from './storeCardDetails.types';

const StoreCardDetails: FC<StoreCardDetailsProps> = (props) => {
  const {
    customTitle,
    phoneNumberTitle,
    description,
    holderLastName,
    holderName,
    kind,
    address,
    schedule,
    accessCodeId,
    offerId,
    couponId,
    phoneNumbers,
    websitesTitle,
    websites,
    accessCodeIdTitle,
    couponsTitle,
    kindTitle,
    offersTitle,
    scheduleTitle,
    titleColor,
    textColor,
    otherContacts,
    additionalFields,
    endDateTitle,
    endDate,
    holderWebsite,
    holderWebsiteTitle
  } = props;

  return (
    <Container>
      <Section>
        <Title textColor={titleColor}>{kindTitle ? kindTitle : 'type'}</Title>
        <Value textColor={textColor}>{kind}</Value>
      </Section>
      <Divider />

      {additionalFields?.map((el, i) => (
        <Fragment key={i}>
          <Section>
            <Title textColor={titleColor}>
              {el.title ? el.title : 'title'}
            </Title>
            <Value textColor={textColor}>{el.value}</Value>
          </Section>
          <Divider />
        </Fragment>
      ))}
      <Section>
        <Title textColor={titleColor}>{holderName}</Title>
        <Value>{holderLastName}</Value>
      </Section>
      <Divider />
      <Section>
        {address.map((el, i) => (
          <Fragment key={i}>
            <Title textColor={titleColor}>
              {el.title ? el.title : 'address'}
            </Title>
            <Value textColor={textColor}>{el.value}</Value>
          </Fragment>
        ))}
      </Section>
      <Divider />

      <Section style={{ flexDirection: 'column' }}>
        <Title textColor={titleColor}>
          {scheduleTitle ? scheduleTitle : 'schedule'}
        </Title>
        <Value textColor={textColor} style={{ whiteSpace: 'pre-line' }}>
          {schedule}
        </Value>
      </Section>
      {customTitle && description && (
        <Section>
          <Title textColor={titleColor}>{customTitle}</Title>
          <Value textColor={textColor}>{description}</Value>
        </Section>
      )}
      <Divider />
      <Section>
        <Title textColor={titleColor}>
          {accessCodeIdTitle ? accessCodeIdTitle : 'barcode'}
        </Title>
        <Value textColor={textColor}>{accessCodeId}</Value>
      </Section>
      <Divider />
      <Section>
        <Title textColor={titleColor}>
          {offersTitle ? offersTitle : 'offers'}
        </Title>
        <Value textColor={textColor}>{offerId}</Value>
      </Section>
      <Divider />
      <Section>
        <Title textColor={titleColor}>
          {couponsTitle ? couponsTitle : 'coupons'}
        </Title>
        <Value textColor={textColor}>{couponId}</Value>
      </Section>
      <Divider />

      <Section style={{ flexDirection: 'column' }}>
        <Title textColor={titleColor}>{phoneNumberTitle}</Title>
        <div>
          {phoneNumbers?.map((el, i) => (
            <Row key={i}>
              <Value textColor={textColor}>
                {el.title ? el.title : 'Commercial phone'}
              </Value>
              <Value isBlue textColor={textColor}>
                {el.value}
              </Value>
            </Row>
          ))}
        </div>
      </Section>
      {holderWebsite && (
        <Fragment>
          <Divider />
          <Section>
            <Title textColor={titleColor}>
              {holderWebsiteTitle ? holderWebsiteTitle : 'Website'}
            </Title>
            <Value isBlue textColor={textColor}>
              {holderWebsite}
            </Value>
          </Section>
        </Fragment>
      )}
      {!!otherContacts?.length && (
        <Fragment>
          <Divider />
          <Section>
            <div>
              {otherContacts?.map((el, i) => (
                <Row key={i}>
                  <Value textColor={textColor}>
                    {el.title ? el.title : 'other'}
                  </Value>
                  <Value isBlue textColor={textColor}>
                    {el.value}
                  </Value>
                </Row>
              ))}
            </div>
          </Section>
        </Fragment>
      )}

      {websites.some((el) => el.value) && (
        <Fragment>
          <Divider />
          <Section style={{ flexDirection: 'column' }}>
            <Title textColor={titleColor}>
              {websitesTitle ? websitesTitle : 'Social media'}
            </Title>
            <div>
              {websites?.map(
                (el, i) =>
                  el.value && (
                    <Row key={i} style={{ flexWrap: 'wrap' }}>
                      <Value textColor={textColor}>
                        {el.title ? el.title : 'Website'}
                      </Value>
                      <Value isBlue textColor={textColor}>
                        {el.value}
                      </Value>
                    </Row>
                  )
              )}
            </div>
          </Section>
        </Fragment>
      )}
      <Divider />
      <Section>
        <Title textColor={titleColor}>
          {endDateTitle ? endDateTitle : 'end date'}
        </Title>
        <Value textColor={textColor}>{endDate}</Value>
      </Section>
    </Container>
  );
};

export default StoreCardDetails;
